import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas, listupdater } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../component/Button';
import Select from '../../component/Select';
import Radios from '../../component/Radios';
import Input from '../../component/Input';
import ListsettingPop from '../../component/ListsettingPop';
import ProductDetailPop from '../../component/ProductDetailPop';
import ProductSendPop from '../../component/ProductSendPop';
import ProductTogetherPop from '../../component/ProductTogetherPop';
import SwiperStyle1 from '../../component/SwiperStyle1';
import consts from '../../libs/consts';

import { Map, Circle, MapMarker } from "react-kakao-maps-sdk"
import AddrSelector from '../../component/AddrSelector';
import * as APIS from "../../utils/service";

import { getMemberinfo, numFormat, useIntersectionObserver, polygon_point_check, hpHypen } from "../../utils/utils";
import Checkbox from '../../component/Checkbox';

import queryString from 'query-string';
import { set } from 'date-fns';

const { kakao } = window;

export default function Customersendlist({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const query = queryString.parse(location.search);
    const { configdata } = useSelector(s => s.configReducer);
    const mapRef = useRef(null);


    let statusArrs = [];
    configdata?.consts?.itemStatusConsts?.map((x, i) => {
        if(x?.idx*1 === 98){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'green', 'no', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 1){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 2){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 3){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else {
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx});
        }
    });
    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx}
    })
    //console.log(category_1_setting);
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx, category_1: x?.category_1}
    })

    const statusName = statusArrs;
    
    const [infoviewer, setinfoviewer] = useState(false); 
    const [nolistflag, setnolistflag] = useState(false); 
    const [detailinfos, setdetailinfos] = useState([
        {viewernames: '거래형태', values: '월세'},
        {viewernames: '매물종류', values: '상업용 > 상가'},
        {viewernames: '희망지역', values: '마포구 전체'},
        {viewernames: '희망면적', values: '23평~25평'},
        {viewernames: '보증금', values: '5,000만원'},
        {viewernames: '월세', values: '200만원'},
        {viewernames: '연식', values: '2020년 이후'},
        {viewernames: '입주시기', values: '2024년 1월 22일'},
    ]); 
    const [sendlists, setsendlists] = useState([
        {data1: true, data2: '동교동', data3: '20평', data4: '월세 3,000/200'},
        {data1: false, data2: '동교동', data3: '20평', data4: '월세 3,000/200'},
        {data1: false, data2: '동교동', data3: '20평', data4: '월세 3,000/200'},
    ]);   
    const [latlng, setlatlng] = useState({lat: 33.450701, lng: 126.570667 });   
    const [selitems, setselitems] = useState(0);   
    const [popflag, setpopflag] = useState(false); 
    const [popcomments, setpopcomments] = useState(''); 
    const [popcommentActive, setpopcommentActive] = useState(true); 
    const [memoIdx, setmemoIdx] = useState(''); 
    const [errmsg, seterrmsg] = useState('');   
    const [SendDatas, setSendDatas] = useState({});   
    const [isagrees, setisagrees] = useState(false);   
    const [isagreesorder, setisagreesorder] = useState(false);   
    const [quetion_check, setquetion_check] = useState([]);
    const [quetion_check2, setquetion_check2] = useState([]);
    const selFontSize = 11;

    const [row, setrow] = useState({}); 
    useEffect(() => {
        seterrmsg('');
    }, [popcomments]);
    useEffect(() => {
        rowDataSubmit();
    }, []);
    const rowDataSubmit = () => {
        let sender = { token: query?.token }
        console.log(sender);
        APIS.postData('/textdecrypt', sender).then(({ data }) => {
            console.log("data", data);
            let customerex = data?.split('cutomerget=');
            //let customerex = 10515;
            if(data){
                dispatch(loadingflas({ loading: true }));
                let sender = { idx: customerex }
                APIS.postData('/v1/customer/kakaocustomerget', sender).then(({ data }) => {
                    if(data){
                        const { customer, sendlist } = data;
                        console.log("!!!!!!!!!!!!!!!!!", data);
                        //console.log(companyGroups);
                        let SendDatas = customer;
                        setrow(customer);
                        setSendDatas(customer);
                        let wantAreas = SendDatas?.citys?.filter(item => item?.polygon === null)?.map(item => item.dong === '전체' ? item.sigungu+" 전체" : item.dong)?.join(", ");
                        wantAreas += SendDatas?.citys?.filter(item => item?.polygon !== null)?.map((item, index) => (index === 0 && SendDatas?.citys?.filter(item => item?.polygon === null)?.length > 0) ? ", 폴리곤"+(index+1) : "폴리곤"+(index+1) )?.join(", ");
        
                        setdetailinfos([
                            {viewernames: '거래형태', values: SendDatas?.sell_type},
                            {viewernames: '매물종류', values: category_2_setting?.find(item => item?.values*1 === SendDatas?.category_2*1)?.names},
                            {viewernames: '희망지역', values: wantAreas},
                            {viewernames: SendDatas?.sell_type === '매매' ? '매매가' : '보증금', values: `${numFormat(SendDatas?.price_all_min)}만원 ~ ${numFormat(SendDatas?.price_all_max)}만원`},
                            {viewernames: '월세', values: `${numFormat(SendDatas?.price_month_min)}만원 ~ ${numFormat(SendDatas?.price_month_max)}만원`},
                            {viewernames: '권리금', values: `${numFormat(SendDatas?.price_key_min)}만원 ~ ${numFormat(SendDatas?.price_key_min)}만원`},
                            {viewernames: '실투자금', values: `${numFormat(SendDatas?.price_real)}만원`},
                            {viewernames: '희망 층수', values: `${numFormat(SendDatas?.item_floor_min)}층 ~ ${numFormat(SendDatas?.item_floor_max)}층`},
                            {viewernames: '희망 면적', values: `${numFormat(SendDatas?.item_area_min)}㎡ ~ ${numFormat(SendDatas?.item_area_max)}㎡`},
                            {viewernames: '희망 연식', values: `${SendDatas?.item_year_min}년 ~ ${SendDatas?.item_year_max}년`},
                            {viewernames: '입주시기', values: `${SendDatas?.in_year} ${SendDatas?.in_year_option1 ? '협의가능' : ''}  ${SendDatas?.in_year_option2 ? '상관없음' : ''}`},
                        ]);  
                        setsendlists(sendlist);
                        setlatlng({lat: sendlist[0]?.item?.lat, lng: sendlist[0]?.item?.lng });
                        // setselitems(sendlist[0]?.item?.idx);
                        setselitems(0); // 접속시 안열린상태로 처리 - j
                        if(customer?.iskakaoagree*1 === 0){
                            //개인정보팝업오픈
                            setisagrees(true);
                        } else {
                            setisagrees(false);
                        }
                    }
                }).catch(({ response }) => {
                    const { data } = response;
                    console.log(data);
                }).finally(() => {
                    dispatch(loadingflas({ loading: false }));
                });   
            }
        }).catch(({ response }) => {
            const { data } = response;
            dispatch(
                open({
                    component: `잘못된 토큰정보입니다.`,
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                })
            ); 
        }).finally(() => {
        });   
    }

    const productView = (selitems, memoidx) => {
        let sender2 = { 
            idx: sendlists?.find(item => item?.i_idx === selitems)?.idx
        }
        APIS.postData('/v1/customer/kakaocustomerviewupdate', sender2).then(({ data }) => {
            console.log("data", data);
        }).catch(({ response }) => {
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });  

        let sender = { encrypttxt: 'itemDetail?itemget='+selitems }
        APIS.postData('/textencrypt', sender).then(({ data }) => {
            console.log("data", data);
            if(data){
                navigate('/?itemtoken='+data, {state: { position_open: row?.position_open, memoidx: memoidx}});
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });          
    }

    useEffect(() => {
        if (!location.hash) {
            setnolistflag(false);
            setpopflag(false);
        } else {
            if(location.hash.indexOf("nolist") >= 0){
                setnolistflag(true)
            }else{
                setnolistflag(false)
            }

            if(location.hash.indexOf("popflag") < 0){
                setpopflag(false);
            }
        }
    }, [location])

    return(
        <>
            {isagrees === true &&
            <div
                style={{
                    position: 'absolute', left: 0, top: 124,
                    width: '100%', height: 'calc(100% - 124px)', padding: 20,
                    overflow: 'auto', zIndex: 1003, backgroundColor: '#fff'
                }}
            >
                <div style={{ backgroundColor: '#6164A5', padding: 5, borderRadius: 5, color: '#fff' }}>
                일번가부동산 김모두 직원이 고객님께 매물 정보를 전달하였습니다. 매물 정보 확인을 위해서는 서비스 이용에 동의가 필요합니다. 
                </div>
                <div>
                    <img src="./images/iskakaoagreeimg.png" width='100%' />
                </div>
                <div
                    style={{
                        position: 'fixed', left: 0, bottom: 10, width: '100%',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}
                >
                    <button
                        type="button"
                        onClick={() => {
                            setisagreesorder(true);
                        }}
                        style={{
                            height: 40, padding: "0px 30px",
                            backgroundColor: '#6165A5', borderRadius: 100, fontWeight: 700, color: '#fff'
                        }}
                    >
                        매물 정보 확인하기
                    </button>
                </div>
                {isagreesorder === true &&
                <div
                    style={{
                        position: 'fixed', left: 0, bottom: 0, width: '100%', padding: 20, backgroundColor: '#fff',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        borderTopLeftRadius: 20, borderTopRightRadius: 20,
                        borderTop: '1px solid #ddd'
                    }}
                >
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4
                    }}>
                        <div>
                            <p style={{ fontSize: 12 }}>에이피링스 주식회사의 중개사 ERP 시스템 모두의매물을 이용중인 모두의매물의 중개서비스를 제공받기 위해서는 다음 개인정보 수집·이용 및 제3자 제공에 관한 동의가 필요합니다. </p>
                            <p style={{ marginTop: 20, fontSize: 12, fontWeight: 700 }}>◼︎ 개인정보 수집ㆍ이용 내역</p>
                            <table className='contractTable' style={{
                                border: "1px", marginTop: 4
                            }}>
                                <tr>
                                    <td style={{ width: "calc(100% / 3)", textAlign: "center", fontSize: selFontSize }}>수집ㆍ이용 목적</td>
                                    <td style={{ width: "calc(100% / 3)", textAlign: "center", fontSize: selFontSize }}>수집 항목</td>
                                    <td style={{ width: "calc(100% / 3)", textAlign: "center", fontSize: selFontSize }}>보유ㆍ이용 기간</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center", fontSize: selFontSize }} className="bolds">공인중개사 및 중개보조원 회원의 중개 서비스 제공</td>
                                    <td style={{ textAlign: "center", fontSize: selFontSize }}>연락처</td>
                                    <td style={{ textAlign: "center", fontSize: selFontSize }}>서비스 목적 달성시까지</td>
                                </tr>
                            </table>

                            <p style={{ marginTop: 20, fontSize: 12, fontWeight: 700 }}>◼︎ 개인정보 제3자 제공 동의</p>
                            <table className='contractTable' style={{
                                border: "1px", marginTop: 4
                            }}>
                                <tr>
                                    <td style={{ width: "25%", textAlign: "center", fontSize: selFontSize }}>제공받는자</td>
                                    <td style={{ width: "20%", textAlign: "center", fontSize: selFontSize }}>제공 항목</td>
                                    <td style={{ width: "30%", textAlign: "center", fontSize: selFontSize }}>제공 목적</td>
                                    <td style={{ width: "25%", textAlign: "center", fontSize: selFontSize }}>보유ㆍ이용 기간</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center", fontSize: selFontSize }} className="bolds">모두의매물</td>
                                    <td style={{ textAlign: "center", fontSize: selFontSize }}>연락처</td>
                                    <td style={{ textAlign: "center", fontSize: selFontSize }} className="bolds">고객의 요청에 따른
                                    매물 정보 전달 및
                                    고객 관리 등
                                    중개서비스 및 상담</td>
                                    <td style={{ textAlign: "center", fontSize: selFontSize }} className="bolds">서비스 목적 달성시까지</td>
                                </tr>
                            </table>
                            <p style={{ marginTop: 10, fontSize: 10 }}><b>✻</b> 위와 같이 개인정보를 제공하는데 동의를 거부할 권리가 있습니다.</p>
                            <p style={{ fontSize: 10 }}>그러나 동의를 거부할 경우 담당 중개사 및 중개보조원의 중개서비스 제공을 받으실 수 없습니다.</p>
                        </div>
                        <Checkbox
                            linetype={'checkimg'}
                            values={quetion_check}
                            setvalues={(e) => {
                                // console.log(e);
                                setquetion_check(e);
                            }}
                            namevalue={[
                                { names: '개인정보 수집ㆍ활용에 동의합니다.', values: 1 },
                            ]}
                            fontweights={400}
                            fontSizes={14}
                            sizes={20}
                        />
                        <div 
                        style={{ 
                            marginTop: 10,
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10
                        }}
                        >
                            <button
                                type="button"
                                onClick={() => {
                                    setisagreesorder(false);
                                }}
                                style={{
                                    height: 40, width: 120, padding: "0px 30px", 
                                    backgroundColor: '#666', borderRadius: 100, fontWeight: 700, color: '#fff'
                                }}
                            >
                                닫기
                            </button>                            
                            <button
                                type="button"
                                onClick={() => {
                                    if(quetion_check?.length < 1){
                                        console.log(quetion_check);
                                        dispatch(
                                            open({
                                                component: `개인정보 수집 활동에 동의해주세요.`,
                                                title: '알림',
                                                titleviewer: true,
                                                alert: false,
                                                button: "확인",
                                                onPress: () => {
                                                    dispatch(close());
                                                }
                                            })
                                        ); 
                                        return;
                                    }
  
                                    let sender2 = {
                                        idx: row?.idx
                                    }
                                    APIS.postData('/kakaosendisagree', sender2).then(({ data }) => {
                                        if(data){
                                            rowDataSubmit();
                                        }
                                    }).catch(({ response }) => {
                                    }).finally(() => {
                                    });  
                                }}
                                style={{
                                    height: 40, padding: "0px 30px", width: 'calc(100% - 120px)',
                                    backgroundColor: '#6165A5', borderRadius: 100, fontWeight: 700, color: '#fff'
                                }}
                            >
                                확인
                            </button>
                        </div>
                    </div>
                </div>
                }
            </div>
            }
            <div className='ProductDetailArea'>
                <div>
                    <div className='ProductDetailAreaBG' 
                        onClick={() => {
                        }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop" > 
                        <div className="ProductSendProfile padding32" >
                            <div
                                style={{
                                    backgroundImage: "url('"+ consts.s3url +"/"+ SendDatas?.user?.profile +"')",
                                    backgroundSize: `${SendDatas?.user?.profile ? "cover" : ""}`
                                }}                                
                            >
                                {!SendDatas?.user?.profile &&
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M26.6663 29.3334H5.33301V26.6667C5.33301 22.9848 8.31778 20 11.9997 20H19.9997C23.6815 20 26.6663 22.9848 26.6663 26.6667V29.3334ZM15.9997 17.3334C11.5814 17.3334 7.99967 13.7516 7.99967 9.33337C7.99967 4.91509 11.5814 1.33337 15.9997 1.33337C20.4179 1.33337 23.9997 4.91509 23.9997 9.33337C23.9997 13.7516 20.4179 17.3334 15.9997 17.3334Z" fill="#CCCCCC"/>
                                </svg>                        
                                }       
                            </div>
                            <div>
                                <div>{SendDatas?.compony?.title}</div>
                                <div>{SendDatas?.user?.name} {SendDatas?.user?.rank}({hpHypen(SendDatas?.user?.hp || '')})</div>
                                <div>{SendDatas?.compony?.addr}</div>
                                <div>{SendDatas?.compony?.company_phone}</div>

                            </div>
                        </div>
                        <div className="ProductSendInfos">
                            <div 
                                className='infoTxts'
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    setinfoviewer(!infoviewer);
                                }}
                            >
                                <span>
                                    고객님 조건&nbsp;
                                    {SendDatas?.sell_type}, &nbsp;
                                    {SendDatas?.sell_type === '월세' ?
                                        <>
                                            보증금({numFormat(SendDatas?.price_all_min)}/{numFormat(SendDatas?.price_all_max)}),
                                            월세({numFormat(SendDatas?.price_month_min)}/{numFormat(SendDatas?.price_month_max)})
                                        </>
                                    :
                                        <>
                                            
                                            <>
                                            {SendDatas?.sell_type === '전세' ?
                                                <>
                                                    보증금({numFormat(SendDatas?.price_all_min)} ~ {numFormat(SendDatas?.price_all_max)})
                                                </>
                                            :
                                                <>
                                                    매매가({numFormat(SendDatas?.price_all_min)} ~ {numFormat(SendDatas?.price_all_max)})
                                                </>
                                            }
                                        </>
                                        </>
                                    }
                                </span>
                                <button>
                                    {infoviewer === false ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M3.57742 6.91073C3.90286 6.5853 4.4305 6.5853 4.75593 6.91073L10 12.1548L15.2441 6.91073C15.5695 6.5853 16.0972 6.5853 16.4226 6.91073C16.748 7.23617 16.748 7.76381 16.4226 8.08925L10.5893 13.9226C10.2638 14.248 9.73619 14.248 9.41075 13.9226L3.57742 8.08925C3.25198 7.76381 3.25198 7.23617 3.57742 6.91073Z" fill="#666666"/>
                                    </svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.41075 6.07742C9.73619 5.75198 10.2638 5.75198 10.5893 6.07742L16.4226 11.9108C16.748 12.2362 16.748 12.7638 16.4226 13.0893C16.0972 13.4147 15.5695 13.4147 15.2441 13.0893L10 7.84519L4.75593 13.0893C4.4305 13.4147 3.90286 13.4147 3.57742 13.0893C3.25198 12.7638 3.25198 12.2362 3.57742 11.9108L9.41075 6.07742Z" fill="#666666"/>
                                    </svg>                                                            
                                    }
                                </button>                                
                            </div>
                            {infoviewer === true &&
                            <div className='infos'>
                                {detailinfos?.length > 0 && detailinfos?.map((x, i) => {
                                    return (
                                        <div key={i}>
                                            <div>{x?.viewernames}</div>
                                            <div>{x?.values}</div>
                                        </div>
                                    );
                                })}
                            </div>                 
                            }           
                        </div>
                        <div>
                            <div className="productlist_th margint20" style={{ gap: 0 }}>
                                <div style={{ minWidth: '40%' }}>위치</div>
                                <div style={{ minWidth: '15%' }}>전용면적</div>
                                <div style={{ minWidth: '25%' }}>가격</div>
                                <div style={{ minWidth: '20%' }}>매물평가</div>
                                {/* <div style={{ minWidth: '10%' }}>제외</div> */}
                            </div>
                            {sendlists?.length > 0 && sendlists?.filter(item => item?.delete_dt === null)?.map((x, i) => {
                                if(x?.delete_dt !== null){
                                    return;
                                }
                                return (
                                    <div key={i}>
                                        <div 
                                            className={`productlist_td`}  style={{ gap: 0, padding: '4px 0px', cursor: 'pointer' }}
                                            onClick={() => {
                                                setlatlng({lat: x?.item?.lat, lng: x?.item?.lng });
                                                
                                                setselitems((selitems*1 > 0 && selitems*1 == x?.item?.idx) ? 0 : x?.item?.idx);
                                                //productView(x?.item?.idx);
                                            }}
                                        >
                                            <div style={{ minWidth: '40%', minHeight: 33, justifyContent: 'flex-start', paddingLeft: 20 }}>
                                                <span style={{ 
                                                    display: 'inline-block', width: 8, height: 8, backgroundColor: selitems === x?.item?.idx ? '#F00' : '',
                                                    borderRadius: '50%', marginRight: 5
                                                }}></span>
                                                {x?.item?.dong}
                                            </div>                                            
                                            <div style={{ minWidth: '15%', minHeight: 33 }}>{x?.item?.area_private}㎡</div>                                            
                                            <div style={{ minWidth: '25%', minHeight: 33 }}>
                                                {x?.item?.sell_type === '월세' ?
                                                    <>
                                                        {numFormat(x?.item?.price_all)}/{numFormat(x?.item?.price_month)}
                                                    </>
                                                :
                                                    <>
                                                        {numFormat(x?.item?.price_sell)}
                                                    </>
                                                }
                                            </div>                                            
                                            <div style={{ minWidth: '20%', minHeight: 33 }} >
                                                <Button 
                                                    buttonTxt={'평가확인'} 
                                                    className={'sendmemobutton'}
                                                    onPress={() => {
                                                        setpopflag(true);
                                                        setmemoIdx(x?.idx);
                                                        setpopcomments(x?.memo);
                                                        setpopcommentActive(x?.memo? false : true)
                                                        window.location.href = `#popflag`
                                                    }}  
                                                />                                            
                                            </div>                                           
                                            {/* <div style={{ minWidth: '10%', minHeight: 33 }} >
                                                <Button 
                                                    buttonTxt={'제외'} 
                                                    disabled={true}

                                                    className={'sendmemobutton'}
                                                    onPress={() => {

                                                        dispatch(
                                                            open({
                                                                component: '제외 하시겠습니까?',
                                                                title: '알림',
                                                                button: "확인",
                                                                buttonCencle: "취소",       
                                                                titleviewer: true,                 
                                                                alert: false,
                                                                onPress: () => {
                                                                    let sender = { idx: x?.idx }
                                                                    // console.log(sender);
                                                                    // return;
                                                                    dispatch(loadingflas({ loading: true }));
                                                                    APIS.postData('/v1/customer/customersendDelete', sender).then(({ data }) => {
                                                                        if(data){
                                                                            //console.log(data, SendDatas);
                                                                            rowDataSubmit();
                                                                            dispatch(
                                                                                open({
                                                                                    component: `제외처리 되었습니다.`,
                                                                                    title: '알림',
                                                                                    titleviewer: true,
                                                                                    alert: false,
                                                                                    button: "확인",
                                                                                    onPress: () => {
                                                                                        dispatch(close());
                                                                                    }
                                                                                })
                                                                            ); 
                                                                        }
                                                                    }).catch(({ response }) => {
                                                                        const { data } = response;
                                                                        console.log(data);
                                                                    }).finally(() => {
                                                                        dispatch(loadingflas({ loading: false }));
                                                                    }); 
                                                                },
                                                                onCancelPress: () => {
                                                                    dispatch(close());
                                                                }
                                                            })
                                                        );  


                                                    }}  
                                                />                                            
                                            </div>                                            */}
                                        </div>
                                        {selitems*1 === x?.item?.idx*1 &&
                                        <div
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10}}
                                        >
                                            <Button 
                                                buttonTxt={'매물 상세정보 확인하기'} 
                                                styles={{
                                                    width: '60%', height: 30, fontSize: 13
                                                }}
                                                className={''}
                                                onPress={() => {
                                                    productView(x?.item?.idx, x?.idx);
                                                }}  
                                            />     
                                        </div>                       
                                        }             
                                    </div>
                                );
                            })}
                        </div>       
                        <div
                            style={{ 
                                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
                                backgroundImage: 'url(./images/samplemap.png)', backgroundPosition: 'center', backgroundSize: 'cover',
                                height: 290
                            }}                        
                        >
                            <Map // 지도를 표시할 Container
                                id="map"
                                center={latlng}
                                style={{
                                    // 지도의 크기
                                    width: "100%",
                                    height: "100%",
                                }}
                                onCenterChanged={(map) => {
                                    const latlng = map.getCenter();
                                    setlatlng({lat: latlng.getLat(), lng: latlng.getLng() });
                                }}
                                level={row?.position_open*1 === 1 ? 4 : 2} // 지도의 확대 레벨
                                ref={mapRef}
                                draggable={false}
                                zoomable={false}
                                disableDoubleClickZoom={true}
                            >  
                                {(row?.position_open*1 === 1 || row?.position_open*1 === 2) &&
                                <Circle
                                    center={latlng}
                                    radius={row?.position_open*1 === 1 ? 250 : 50}
                                    strokeWeight={1} // 선의 두께입니다
                                    strokeColor={"#75B8FA"} // 선의 색깔입니다
                                    strokeOpacity={2} // 선의 불투명도 입니다 1에서 0 사이의 값이며 0에 가까울수록 투명합니다
                                    fillColor={"#CFE7FF"} // 채우기 색깔입니다
                                    fillOpacity={0.7} // 채우기 불투명도 입니다
                                />}
                                {row?.position_open*1 === 3 &&
                                <MapMarker // 마커를 생성합니다
                                    position={latlng}
                                    image={{
                                        src: "./images/icons/map-marker-svgrepo-com.svg", // 마커이미지의 주소입니다
                                        size: {
                                            width: 24,
                                            height: 34,
                                        }, // 마커이미지의 크기입니다
                                    }}                                    
                                />}

                            </Map>
                        </div>
                        <div
                            style={{ position: 'absolute' }}
                        >
                            <div
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    position: 'fixed', left: 0, bottom: 0,
                                    width: '100%', zIndex: 1000
                                }}
                            >
                                <div style={{ width: '30%'}}>
                                    <Button
                                        disabled={true}
                                        buttonTxt={`관심없는${'\n'}매물목록`}
                                        styles={{ 
                                            borderTopLeftRadius: 0,    
                                            borderTopRightRadius: 0,    
                                            borderBottomLeftRadius: 0,    
                                            whiteSpace: 'pre-wrap'
                                        }} 
                                        onPress={() => { 
                                            if(sendlists?.length > 0){
                                                sendlists?.filter(item => item?.delete_dt !== null)?.map((x, i) => {
                                                    if(i === 0){
                                                        setlatlng({lat: x?.item?.lat, lng: x?.item?.lng });
                                                        setselitems(x?.item?.idx);
                                                        setmemoIdx(x?.idx);
                                                    }
                                                });
                                            }
                                            setnolistflag(true);
                                            window.location.href = `#nolist`
                                        }}
                                    />                                    
                                </div>       
                                <div style={{ width: '70%'}}>
                                    <Button
                                        buttonTxt={'담당자에게 전화걸기'}
                                        styles={{ 
                                            borderTopLeftRadius: 0,    
                                            borderTopRightRadius: 0,    
                                            borderBottomRightRadius: 0,    
                                        }} 
                                        onPress={() => { 
                                            //alert(SendDatas?.user?.hp);
                                            window.location.href=`tel:${SendDatas?.user?.hp}`;
                                        }}
                                    />                                    
                                </div>                       
                            </div>
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
            {nolistflag === true &&
            <div className='ProductDetailArea'>
                <div>
                    <div className='ProductDetailAreaBG' 
                        // onClick={() => {
                        //     setnolistflag(false);
                        // }}
                    />

                    <div></div>
                    <div className="ProductSendnolistpop" style={{maxWidth:500,width:"100%"}}> 
                        <div className="popTitle padding20">
                            <span >제외 목록</span>
                            <button
                                onClick={() => {
                                    setnolistflag(false);
                                    navigate(-1);
                                }}
                            >
                                <img src="./images/icons/x.svg" width='20' />                                            
                            </button>
                        </div>
                        <div>
                            <div className="productlist_th " style={{ gap: 0, borderTop: 0 }}>
                                <div style={{ minWidth: '40%' }}>위치</div>
                                <div style={{ minWidth: '15%' }}>전용면적</div>
                                <div style={{ minWidth: '25%' }}>가격</div>
                                <div style={{ minWidth: '20%' }}>평가확인</div>
                            </div>
                            {sendlists?.length > 0 && sendlists?.filter(item => item?.delete_dt !== null)?.map((x, i) => {

                                return (
                                    <>
                                    <div 
                                        className={`productlist_td`} key={i} style={{ gap: 0, padding: '4px 0px', cursor: 'pointer' }}
                                        onClick={() => {
                                            setlatlng({lat: x?.item?.lat, lng: x?.item?.lng });
                                            setselitems(x?.item?.idx);
                                            //productView(x?.item?.idx, , x?.idx);
                                        }}                                        
                                    >
                                        <div style={{ minWidth: '40%', minHeight: 33, justifyContent: 'flex-start', paddingLeft: 20 }}>
                                            <span style={{ 
                                                display: 'inline-block', width: 8, height: 8, backgroundColor: selitems === x?.item?.idx ? '#F00' : '',
                                                borderRadius: '50%', marginRight: 5
                                            }}></span>
                                            {x?.item?.dong}
                                        </div>                                            
                                        <div style={{ minWidth: '15%', minHeight: 33 }}>{x?.item?.area_private}㎡</div>                                            
                                        <div style={{ minWidth: '25%', minHeight: 33 }}>
                                            {x?.item?.sell_type === '월세' ?
                                                <>
                                                    {numFormat(x?.item?.price_all)}/{numFormat(x?.item?.price_month)}
                                                </>
                                            :
                                                <>
                                                    {numFormat(x?.item?.price_sell)}
                                                </>
                                            }
                                        </div>                                            
                                        <div style={{ minWidth: '20%', minHeight: 33 }} >
                                            <Button 
                                                buttonTxt={'메모'} 
                                                className={'sendmemobutton'}
                                                onPress={() => {
                                                    setpopflag(true);
                                                    setmemoIdx(x?.idx);
                                                    setpopcomments(x?.memo);
                                                    setpopcommentActive(x?.memo? false : true)
                                                    window.location.href = `#popflag`;
                                                }}  
                                            />                                            
                                        </div>                                             
                                    </div>
                                    </>
                                );
                            })}
                            {sendlists?.filter(item => item?.delete_dt !== null)?.length === 0 &&
                                <div className='nolistArea'>
                                    제외목록이 없습니다.
                                </div>                        
                            }
                        </div>       
                        {sendlists?.filter(item => item?.delete_dt !== null)?.length > 0 &&
                        <>
                        <div
                            style={{ 
                                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
                                backgroundImage: 'url(./images/samplemap.png)', backgroundPosition: 'center', backgroundSize: 'cover',
                                height: 490
                            }}                        
                        >
                            <Map // 지도를 표시할 Container
                                id="map"
                                center={latlng}
                                style={{
                                    // 지도의 크기
                                    width: "100%",
                                    height: "100%",
                                }}
                                onCenterChanged={(map) => {
                                    const latlng = map.getCenter();
                                    setlatlng({lat: latlng.getLat(), lng: latlng.getLng() });
                                }}
                                level={3} // 지도의 확대 레벨
                                ref={mapRef}
                            >  
                            </Map>
                        </div>
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                width: '100%'
                            }}
                        >
                            <Button
                                buttonTxt={'관심매물로 이동하기'}
                                styles={{ 
                                    borderTopLeftRadius: 0,    
                                    borderTopRightRadius: 0,    
                                }} 
                                onPress={() => { 
                                    // if(types === ''){
                                    //     setproductdetailflag(true);
                                    // }
                                    // setproductsendflag(false);
                                    let sender = { idx: memoIdx }
                                    // console.log(sender);
                                    // return;
                                    dispatch(loadingflas({ loading: true }));
                                    APIS.postData('/v1/customer/customerdeleteUpdate', sender).then(({ data }) => {
                                        if(data){
                                            console.log(data, SendDatas);
                                            rowDataSubmit();
                                            setnolistflag(false);
                                        }
                                    }).catch(({ response }) => {
                                        const { data } = response;
                                        console.log(data);
                                        seterrmsg(data);
                                    }).finally(() => {
                                        dispatch(loadingflas({ loading: false }));
                                    }); 
                                }}
                            />                                    
                        </div>
                        </>
                        }
                    </div>
                    <div></div>
                </div>
            </div>       
            }     

            {popflag === true &&
            <div className='PopupArea'>
                <div>
                    <div className='PopupAreaBG' 
                        //onClick={() => { setpopflag(false); }}
                    />
                    <div className='PopupAreaContents'>
                        <div>
                            <div className="popTitle padding20">
                                <span >고객평가</span>
                                <button
                                    onClick={() => {
                                        setpopflag(false);
                                        navigate(-1);
                                    }}
                                >
                                    <img src="./images/icons/x.svg" width='20' />
                                </button>
                            </div>
                            <div className="padding20">
                                <div className='popcontents'>
                                    <div style={{ width: '100%' }}>
                                        <div style={{ width: '100%' }}>
                                            <textarea
                                                onChange={(e) => {
                                                    setpopcomments(e.target.value);
                                                }}
                                                placeholder=''
                                                style={{
                                                    width: '100%', height: 200, padding: 12,
                                                    borderRadius: 4, border: '1px solid #DDD'
                                                }}
                                                value={popcomments}
                                                disabled={true}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                {errmsg &&
                                <div className='input_error ' style={{ width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                                    {errmsg}
                                </div>}
                            </div>
                            {/* 메모가 있을경우 수정할수 없음 */}
                            {/* {popcommentActive && <div> 
                                <Button
                                    buttonTxt={'확인'}
                                    onPress={() => { 
                                        if(popcomments === '' || popcomments === null){
                                            // seterrmsg('메모를 입력해주세요.');
                                            seterrmsg('매물을 평가하시면 담당자가 확인할 수 있으며, 고객님께 알맞는 매물을 추천하는데 매우 큰 도움이 됩니다.');
                                            return;
                                        }
                                        let sender = { idx: memoIdx, memo: popcomments }
                                        // console.log(sender);
                                        // return;
                                        dispatch(loadingflas({ loading: true }));
                                        APIS.postData('/v1/customer/customersendmemoUpdate', sender).then(({ data }) => {
                                            if(data){
                                                //console.log(data, SendDatas);
                                                rowDataSubmit();
                                                setpopflag(false);
                                                navigate(-1)
                                            }
                                        }).catch(({ response }) => {
                                            const { data } = response;
                                            seterrmsg(data);
                                        }).finally(() => {
                                            dispatch(loadingflas({ loading: false }));
                                        }); 

                                    }}
                                    styles={{ height: 52, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
                                />                                    
                            </div> } */}
                            
                        </div>
                    </div>
                </div>

            </div>
            }
        </>
    )
}
